import { render, staticRenderFns } from "./handoverSheetManage.vue?vue&type=template&id=6a8246f4&scoped=true"
import script from "./handoverSheetManage.vue?vue&type=script&lang=js"
export * from "./handoverSheetManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8246f4",
  null
  
)

export default component.exports